/**
 * created by lzy 2020.05.26
 * 版权资源共享稿库和新华社稿库复合筛选
 */

'use strict';
angular.module('compositeFilterPanelModule', []).directive('compositeFilterPanel', ['$timeout', 'localStorageService', '$sessionStorage', 'iWoService',
    function ($timeout, localStorageService, $sessionStorage, iWoService) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: './resourceCenter/directive/compositeFilterPanel/compositeFilterPanel.html',
            scope: {
                recommendChannels: '@',
                docShareMedia: '=', // 推荐渠道
                takeDraftStatus: '=', // 取稿状态
                singStatus: '=', // 签发状态
                products: '=', // 取签产品
                compositeFilter: '=', // 用于存放指令里的方法、参数，在父控制器直接调用
                alwaysShowProducts: '@', // 是否一直显示取签产品，（目前共享稿库是的，新华社稿库不是）
                callback: '&'
            },
            link: function ($scope, iEle) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.takeDraftStatus = $scope.takeDraftStatus || 0;
                    $scope.singStatus = $scope.singStatus || 0;
                    // $scope.products = $scope.products || '[]';
                    $scope.data = {
                        curUserId: $sessionStorage.get('curUserInfo').ID,
                        draftStatus: [
                            {
                                name: '全部',
                                value: 0
                            }, {
                                name: '已取稿',
                                value: 1
                            }, {
                                name: '未取稿',
                                value: 2
                            }
                        ],
                        issuedState: [
                            {
                                name: '全部',
                                value: 0
                            }, {
                                name: '已签发',
                                value: 1
                            }, {
                                name: '未签发',
                                value: 2
                            }
                        ],
                        takeSignProductsHolder: {
                            0: '取签产品',
                            1: '取签产品',
                            2: '未取稿产品'
                        }
                    };
                    $scope.status = {
                        isShowAll: false,
                        openedPanel: { // 产品打开的折叠面板，默认打开第一个
                            0: true
                        },
                        storage: localStorageService.get('resource.compositeFilter') || {}
                    };
                }

                /**
                 * [initData description] 初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    $scope.takeSignProductsHolder = $scope.data.takeSignProductsHolder[$scope.takeDraftStatus];
                    getSites();
                    bindBlur();
                }

                /**
                 * [getSites description] 获取站点
                 *
                 * @return  {[type]}   [return description]
                 */
                function getSites() {
                    $scope.loadingPromise = iWoService.getProducts().then((data) => {
                        data.splice(0, 1); // 去掉第一个，不展示全部
                        $scope.data.sites = data;
                        $scope.initTakeSignProdcctList(data);
                    });
                }

                /**
                 * [selected description] 取稿状态和签发状态点击选中回调
                 *
                 * @param   {[type]}  type   [type description] 对应的关键字
                 * @param   {[type]}  value  [value description] 选取的值
                 *
                 * @return  {[type]}         [return description]
                 */
                $scope.selected = function (type, value) {
                    $scope[type] = value;
                    $scope.takeDraftStatus === 2 ? $scope.status.isShowAll = false : ''; // 如果选中未取稿，则隐藏产品悬浮面板
                    $scope.takeSignProductsHolder = $scope.data.takeSignProductsHolder[$scope.takeDraftStatus];
                    $timeout(function () {
                        saveStorage(type, value);
                        $scope.callback()(type, value);
                    });

                };

                /**
                 * [setProductName description] 设置产品名称
                 * @param   {[object]}  item    [item description] 产品信息
                 * @return  {[string]}          [return description] 产品名称
                 */
                $scope.setProductName = function (item) {
                    let productName;
                    if (item.SITEDESC) {
                        productName = item.SITENAME.split('-')[0] + '-' + item.SITEDESC;
                    } else if (item.CHNLDESC) {
                        productName = item.SITENAME.split('-')[0] + '-' + item.CHNLDESC;
                    } else {
                        productName = item.SITENAME;
                    }
                    return productName;
                };

                /**
                 * [reset description] 重置方法
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.reset = function () {
                    $scope.products = '[]';
                    $scope.data.productSelectedList = [];
                };

                /**
                 * [confirm description] 确定方法
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.confirm = function () {
                    $scope.status.isShowAll = false;
                    $timeout(function () {
                        saveStorage('products', $scope.products);
                        $scope.callback()('products', $scope.products);
                    });
                };

                /**
                 * [cancel description] 取消方法
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.cancel = function () {
                    $scope.status.isShowAll = false;
                };


                /**
                 * [bindBlur description] 绑定失焦事件
                 * @return {[type]} [description]
                 */
                function bindBlur() {
                    $('body').unbind('click', clickEvent).bind('click', clickEvent);

                    /**
                     * [clickEvent description] 点击事件
                     * @param  {[type]} e [description]
                     * @return {[type]}   [description]
                     */
                    function clickEvent(e) {
                        var $target = $(e.target);
                        if ($target.parents('.composite-filter-panel')[0] === iEle[0]) {
                            // 如果点到按键本身，不失焦
                            return;
                        }
                        $scope.status.isShowAll = false;
                    }
                    $scope.$on('$destroy', function () {
                        $('body').unbind('click', clickEvent);
                    });
                }

                $scope.compositeFilter.saveStorage = function (type, value) {
                    saveStorage(type, value);
                };

                /**
                 * [saveStorage description]存储，将选择项存到localstorage记忆下来
                 *
                 * @param   {[type]}  type   [type description]
                 * @param   {[type]}  value  [value description]
                 *
                 * @return  {[type]}         [return description]
                 */
                function saveStorage(type, value) {
                    if (!$scope.status.storage[$scope.data.curUserId]) {
                        $scope.status.storage[$scope.data.curUserId] = {};
                    }
                    $scope.status.storage[$scope.data.curUserId][type] = value;
                    localStorageService.set('resource.compositeFilter', $scope.status.storage);
                }
            }
        };
    }
]);
